"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaMessageContextPickerSym = exports.TpaModalSymbol = exports.TpaPopupSymbol = exports.TpaSrcQueryParamProviderSymbol = exports.TpaHandlerProviderSymbol = void 0;
exports.TpaHandlerProviderSymbol = Symbol('TpaHandlerProvider');
exports.TpaSrcQueryParamProviderSymbol = Symbol('TpaSrcQueryParamProvider');
exports.TpaPopupSymbol = Symbol('TpaPopup');
exports.TpaModalSymbol = Symbol('TpaModal');
exports.TpaMessageContextPickerSym = Symbol('TpaMessageContextPicker');
//# sourceMappingURL=tpa.js.map